import {Components, Theme} from '@mui/material/styles';
import {MuiButtonOverride} from './components/button';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiButton: MuiButtonOverride,
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        backgroundColor: '#19C7851A',
        color: '#19C785',
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
          borderRadius: '16px',
          border: '1px solid #EFEFEF',
          width: '100%',
        },
        '&:hover fieldset.MuiOutlinedInput-notchedOutline': {
          border: '1px solid #EFEFEF',
        },
        '&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
          border: '1px solid #EFEFEF',
        },
        '& .MuiSelect-select': {
          padding: '10px 16px',
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
          borderRadius: '16px',
          border: '1px solid #EFEFEF',
          width: '100%',
        },
        '&:hover fieldset.MuiOutlinedInput-notchedOutline': {
          border: '1px solid #EFEFEF',
        },
        '&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
          border: '1px solid #EFEFEF',
        },
        '& input': {
          padding: '10px 16px',
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '&:has(.MuiSelect-select) input[value=""]': {
          fontSize: '0.875rem',
          color: '#EFEFEF',
          border: 'none',
          fontWeight: 500,
          top: 0,
          opacity: 1,
        },
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: ({theme}) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '.5rem',
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: ({theme}) => ({
        fontSize: '0.75rem',
        color: theme.palette.grey[500],
        fontWeight: 600,
        backgroundColor: (theme.palette as any).lightGrey[100],
        borderBottom: 'none',
        whiteSpace: 'nowrap',
      }),
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        '&.MuiDialog-paper': {
          maxWidth: '468px',
        },
      },
    },
  },
};
